import React from 'react';
import { motion } from 'framer-motion';
import { GiftIcon, CheckIcon, SmartphoneIcon } from 'lucide-react';
import { bonuses } from '../data/volumes';
import { BonusPackage } from './BonusPackage';
export function Bonuses() {
  return <section aria-label="Bonuses" className="border-y border-line bg-ink-2" data-id="element-17" data-mp="aujyu7fl211w">
      <div className="mx-auto max-w-5xl px-5 py-12" style={{
      paddingTop: "23px",
      paddingBottom: "23px"
    }} data-id="element-18" data-mp="ft4o5btar0bk">
        <div className="text-center" data-id="element-19" data-mp="1styud7mxtsi">
          <h2 className="font-display text-3xl font-bold uppercase text-fog sm:text-4xl" data-id="element-20" data-mp="5w0cw70zop9j">🎁 4 Exclusive Bonuses Included</h2>
          <p className="mt-2 text-sm font-bold uppercase tracking-[0.2em] text-gold" data-id="element-21" data-mp="3o2epa1jm0r5t">Only with this complete offer</p>
          <p className="mx-auto mt-4 max-w-xl text-[15px] text-fog/70" data-id="element-22" data-mp="3t1hj0pu53ayh">
            In addition to the six-volume system, you'll receive four complementary resources designed to support the
            practical use of the main toolkit.
          </p>
        </div>

        <ol className="mt-10 space-y-5" data-id="element-23" data-mp="3ie6ibiheg3w7">
          {bonuses.map(b => <motion.li key={b.n} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-40px'
        }} transition={{
          duration: 0.3,
          ease: [0.23, 1, 0.32, 1]
        }} className="grid gap-5 rounded-2xl border border-gold/25 bg-ink p-5 sm:grid-cols-[150px_1fr] sm:p-6 lg:grid-cols-[170px_1fr_1fr]" data-id="element-24" data-mp="3iclj3fk53ws0">
              <div className="flex items-start gap-4 sm:block" data-id="element-25" data-mp="2uh0qzr09aeu4">
                <img src={b.cover} alt={`${b.title} cover`} width={1122} height={1402} loading="lazy" decoding="async" sizes="170px" className="h-auto w-24 shrink-0 object-contain drop-shadow-[0_14px_22px_rgba(0,0,0,0.6)] sm:w-full" data-id="element-26" data-mp="2uik5pd69khts" />
                <div className="sm:hidden" data-id="element-27" data-mp="npi30a633srl">
                  <BonusBadge n={b.n} value={b.value} data-id="element-28" data-mp="no6opgf0j2m8" />
                  <h3 className="mt-2 font-display text-lg font-bold uppercase leading-tight text-fog" data-id="element-29" data-mp="irgayzqokj3z">{b.title}</h3>
                </div>
              </div>

              <div className="min-w-0" data-id="element-30" data-mp="3cl0sczvj44fq">
                <div className="hidden sm:block" data-id="element-31" data-mp="3hhhpukombv5h">
                  <BonusBadge n={b.n} value={b.value} data-id="element-32" data-mp="3hk3zqqyzemqv" />
                  <h3 className="mt-3 font-display text-xl font-bold uppercase leading-tight text-fog" data-id="element-33" data-mp="3ljct3uq40ilw">{b.title}</h3>
                </div>
                <p className="text-sm font-semibold text-teal sm:mt-1" data-id="element-34" data-mp="3qhwdvrsyvoco">{b.subtitle}</p>
                <p className="mt-2 text-sm leading-relaxed text-fog/70" data-id="element-35" data-mp="2ttzy2p5csx2i">{b.desc}</p>
                <p className="mt-3 text-sm leading-relaxed text-fog/75" data-id="element-36" data-mp="2xv1uky7vyv0s">
                  <span className="font-bold text-gold" data-id="element-37" data-mp="32sl9m0cerbts">Why it matters:</span> {b.why}
                </p>
              </div>

              <div className="sm:col-span-2 lg:col-span-1 lg:border-l lg:border-line lg:pl-6" data-id="element-38" data-mp="37klhqg2mtb1g">
                <p className="text-xs font-bold uppercase tracking-wider text-fog/50" data-id="element-39" data-mp="2a3egjgvq3efx">Inside this bonus</p>
                <ul className="mt-3 space-y-2" data-id="element-40" data-mp="2f27rp2njetcx">
                  {b.includes.map(item => <li key={item} className="flex items-start gap-2 text-sm text-fog/80" data-id="element-41" data-mp="27kjaisdvi1ik">
                      <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-teal" strokeWidth={3} aria-hidden="true" data-id="element-42" data-mp="22kewd90ftivi" />
                      {item}
                    </li>)}
                </ul>
              </div>
            </motion.li>)}
        </ol>

        <BonusPackage data-id="element-43" data-mp="1tjp0y6f39uib" />

        
      </div>
    </section>;
}
function BonusBadge({
  n,
  value
}: {
  n: string;
  value: string;
}) {
  return <div className="flex flex-wrap items-center gap-x-3 gap-y-1" data-id="element-44" data-mp="1juf82ocf87t5">
      <span className="inline-flex items-center gap-1.5 whitespace-nowrap rounded-md bg-gold px-2.5 py-1 text-xs font-extrabold uppercase text-ink" data-id="element-45" data-mp="1jt47syi6pi6s">
        <GiftIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-46" data-mp="19wrc5v32wu9e" /> Bonus {n}
      </span>
      <span className="whitespace-nowrap text-xs font-bold" data-id="element-47" data-mp="15ue8rdbt18fs">
        <span className="text-fog/45 line-through" data-id="element-48" data-mp="15tup9s6iabzn">{value}</span> <span className="text-teal" data-id="element-49" data-mp="10vb4vw7k989e">INCLUDED FREE</span>
      </span>
    </div>;
}